import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import priceDataService from '../../../core/services/Prices/PriceData/PriceDataService';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { getCodeFromQuery } from '../../helpers/Common';
import BidAskInfo from './BidAskInfo';
import SearchBox from '../search-box/SearchBox';
import './search-box-with-data.scss';
import PriceInfo from './PriceInfo';

const defaultData = { priceInfo: {}, bidAskInfo: null };

class SearchBoxWithData extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentSearch: this.props.defaultCurrentSearch,
      data: defaultData,
    };
  }

  async componentDidMount() {
    this._mounted = true;
    const code = getCodeFromQuery();
    if (code) {
      this.changeCode(code);
    } else {
      this.fetchData();
    }
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentSearch, data } = this.state;
    const { onPriceChange } = this.props;
    if (currentSearch.code !== prevState.currentSearch.code) {
      this.unSubscribeData(prevState.currentSearch);
    }
    if (data !== prevState.data) {
      onPriceChange(data.priceInfo);
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    const { currentSearch } = this.state;
    this.unSubscribeData(currentSearch);
  }

  fetchData = async () => {
    const { currentSearch } = this.state;
    const res = await priceDataService.getLatestPrice({
      Code: currentSearch.code,
    });
    const codeData = res.items && res.items[0] ? res.items[0] : defaultData;
    if (!this._mounted) {
      return;
    }
    this.setState({
      data: codeData,
    });
    this.subscribeData();
  };

  subscribeData = () => {
    const { currentSearch } = this.state;
    if (currentSearch.isTicker) {
      MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
      MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
    } else {
      MessageHub.subscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    }
  };

  unSubscribeData = currentSearch => {
    if (currentSearch.isTicker) {
      MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
      MessageHub.unsubscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
    } else {
      MessageHub.unsubscribe(ChanelConfig.IndexChannel, this.onReceiveIndex);
    }
  };

  onReceiveBidAsk = tickers => {
    const { currentSearch, data } = this.state;
    const ticker = tickers.find(item => item.organCode === currentSearch.code);
    if (ticker) {
      this.setState({
        data: {
          ...data,
          bidAskInfo: ticker,
        },
      });
    }
  };

  onReceiveTicker = tickers => {
    const { currentSearch, data } = this.state;
    const ticker = tickers.find(item => item.organCode === currentSearch.code);
    if (ticker) {
      this.setState({
        data: {
          ...data,
          priceInfo: ticker,
        },
      });
    }
  };

  onReceiveIndex = indexs => {
    const { currentSearch, data } = this.state;
    const index = indexs.find(item => item.comGroupCode === currentSearch.code);
    if (index) {
      this.setState({
        data: {
          ...data,
          priceInfo: {
            ...data.priceInfo,
            matchPrice: index.indexValue,
            percentPriceChange: index.percentIndexChange,
            priceChange: index.indexChange,
          },
        },
      });
    }
  };

  changeCode = code => {
    const { onChangeCode } = this.props;
    this.setState(
      {
        currentSearch: code,
        data: defaultData,
      },
      this.fetchData,
    );
    onChangeCode(code);
  };

  render() {
    const { currentSearch, data } = this.state;

    return (
      <div className="search-box-with-data align-items-center d-flex">
        <div className="mr-5">
          <SearchBox
            changeCode={this.changeCode}
            currentSearch={currentSearch}
          />
        </div>

        <div className="d-flex">
          <PriceInfo priceInfo={data.priceInfo} />

          {data.bidAskInfo && (
            <BidAskInfo
              priceInfo={data.priceInfo}
              bidAskInfo={data.bidAskInfo}
            />
          )}
        </div>
      </div>
    );
  }
}

SearchBoxWithData.propTypes = {
  defaultCurrentSearch: PropTypes.object,
  onChangeCode: PropTypes.func,
};

SearchBoxWithData.defaultProps = {
  defaultCurrentSearch: {
    code: 'AAA',
    displayCode: 'AAA',
    isTicker: true,
  },
  onChangeCode: () => {},
  onPriceChange: () => {},
};

export default SearchBoxWithData;
